import { FinancialAccountReportRequestModel } from '../api/models/FinancialAccountReportRequestModel';

export const dataFormToRequest = (
  data: FinancialAccountReportRequestModel
): FinancialAccountReportRequestModel => ({
  from: data.from,
  is_open: data.is_open,
  to: data.to,
  order_by: data.order_by,
  with_balance: data.with_balance,
  file_type: data?.file_type,
});
